import React, { HTMLAttributes } from 'react';

import { CustomCheckBox } from './styles';

interface CheckboxProps extends HTMLAttributes<HTMLDivElement> {
  checked: boolean;
}

const CustomCheckbox: React.FC<CheckboxProps> = ({ checked, ...rest }) => {
  return (
    <CustomCheckBox
      checked={checked}
      {...rest}
    >
      { checked ? 'Produto\nDestacado' : 'Destacar\nProduto' }
    </CustomCheckBox>
  );
};

export default CustomCheckbox;
